import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { fetchCompaniesWithBrands } from "../api/internal_tool_endpoints";

// Async thunk to fetch companies with brands
export const fetchCompaniesWithBrandsData = createAsyncThunk(
  "competitors/fetchCompaniesWithBrands",
  /** @param {{ id_client: any; country: string }} arg */
  async ({ id_client, country }, { rejectWithValue }) => {
    try {
      const data = await fetchCompaniesWithBrands({ id_client, country });
      return data;
    } catch (error) {
      return rejectWithValue(error.message);
    }
  }
);

const initialState = {
  companiesWithBrands: {
    companies: []
  },
  loading: false,
  error: null,
  selectedCompetitors: {
    companies: [],
    brands: []
  }
};

const competitorsSlice = createSlice({
  name: "competitors",
  initialState,
  reducers: {
    // Set selected competitors (companies and brands)
    setSelectedCompetitors: (state, action) => {
      state.selectedCompetitors = action.payload;
    },
    
    // Add a company to selected competitors
    addSelectedCompany: (state, action) => {
      const company = action.payload;
      if (!state.selectedCompetitors.companies.find(c => c.company === company.company)) {
        state.selectedCompetitors.companies.push(company);
      }
    },
    
    // Remove a company from selected competitors
    removeSelectedCompany: (state, action) => {
      const companyName = action.payload;
      state.selectedCompetitors.companies = state.selectedCompetitors.companies.filter(
        c => c.company !== companyName
      );
      // Also remove all brands from this company
      state.selectedCompetitors.brands = state.selectedCompetitors.brands.filter(
        b => b.company !== companyName
      );
    },
    
    // Add a brand to selected competitors
    addSelectedBrand: (state, action) => {
      const { brand, company } = action.payload;
      const existingBrand = state.selectedCompetitors.brands.find(
        b => b.id_brand === brand.id_brand
      );
      if (!existingBrand) {
        state.selectedCompetitors.brands.push({
          ...brand,
          company: company
        });
      }
    },
    
    // Remove a brand from selected competitors
    removeSelectedBrand: (state, action) => {
      const brandId = action.payload;
      state.selectedCompetitors.brands = state.selectedCompetitors.brands.filter(
        b => b.id_brand !== brandId
      );
    },
    
    // Clear all selected competitors
    clearSelectedCompetitors: (state) => {
      state.selectedCompetitors = {
        companies: [],
        brands: []
      };
    },
    
    // Reset competitors state
    resetCompetitorsState: (state) => {
      Object.assign(state, initialState);
    }
  },
  extraReducers: (builder) => {
    builder
      // Fetch companies with brands
      .addCase(fetchCompaniesWithBrandsData.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchCompaniesWithBrandsData.fulfilled, (state, action) => {
        state.loading = false;
        state.companiesWithBrands = action.payload;
        state.error = null;
      })
      .addCase(fetchCompaniesWithBrandsData.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      });
  }
});

export const {
  setSelectedCompetitors,
  addSelectedCompany,
  removeSelectedCompany,
  addSelectedBrand,
  removeSelectedBrand,
  clearSelectedCompetitors,
  resetCompetitorsState
} = competitorsSlice.actions;

export default competitorsSlice.reducer;